import React, { useEffect, useState } from 'react'
import Header from '../componets/header/header'
import Footer from '../componets/footer/footer'
import courseback from "../../assets/course-back.jpg"
// @ts-ignore
import "./Course.css"
import { GET, POST } from '../../utils/apicalls'
import { API } from '../../config/api'
import { Button, Rate } from 'antd'
import { SearchOutlined, ShareAltOutlined } from '@ant-design/icons'
import { useNavigate, useParams } from 'react-router-dom'
import EnrollModal from '../booking-payment/enrollmentModel'
import loading from '../../assets/loading.gif'
import { Helmet } from 'react-helmet'

function Coursepage() {
    const [allCategoryData, setallCategoryData] = useState<any>([]);
    const [allCourseData, setallCourseData] = useState<any>([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [CourseFilterData, setCourseFilterData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
    const navigate = useNavigate(); // Initialize useNavigate hook for navigation
    const [selectedCourseForEnroll, setSelectedCourseForEnroll] = useState<string | number | null>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { id } = useParams(); // get category id from URL
    // Update the showModal function
    const showModal = (courseId: string | number, e: React.MouseEvent) => {
        e.stopPropagation(); // Stop event propagation to prevent navigation
        setSelectedCourseForEnroll(courseId);
        setIsModalVisible(true);
    };

    // Update the handleCloseModal function
    const handleCloseModal = () => {
        setIsModalVisible(false);
        setSelectedCourseForEnroll(null); // Reset selected course when closing
    };

    const filterCourseData = async (values: any) => {
        try {
            setIsLoading(true);
            const api = API.FILTER_COURSE;
            const response: any = await POST(api, values);

            if (response?.data) {
                setCourseFilterData(response.data);
            } else {
                console.error("Data not available:", response);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSearch = () => {
        if (searchQuery.trim()) {
            filterCourseData({ title: searchQuery });
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };

    const categories = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_CATEGORIES, {});
            setallCategoryData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    const courses = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSES, {});
            setallCourseData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        courses();
        categories();
    }, []);

    const filteredCourses = allCourseData.filter((course: any) => {
        const matchesCategory = selectedCategoryId ? course.category_id === selectedCategoryId : true;
        const matchesSearch = searchQuery ? course.course_title.toLowerCase().includes(searchQuery.toLowerCase()) : true;
        return matchesCategory && matchesSearch;
    });
    const handleViewDetails = (courseId: number) => {
        navigate(`/course/${courseId}`);
        window.scrollTo(0, 0); // Scroll to top after navigation
    };
    // function getRatingById(id: number): number {
    //     const ratings = [5, 5, 5, 5, 5, 5, 5, 5]; // pre-defined rating values
    //     return ratings[id % ratings.length]; // pseudo-random assignment
    // }
    function getRatingById(id: number): number {
        return 5;
    }
    const shareOnWhatsApp = (course: any) => {
        const courseId = course?.id; // or course?.courseId depending on your data structure
        if (!courseId) {
            console.error("Course ID is undefined:", course);
            return;
        }

        const url = `https://meantoir.com/course/${courseId}`;
        const message = `Check out this course: ${course.course_title} - ${url}`;
        window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
    };
    const preferredOrder = ["Tax", "Finance & Accounting", "Auditing & Investigation"];
    const orderedCategoryData = [
        ...allCategoryData.filter((c: any) => preferredOrder.includes(c.categoryTitle))
            .sort((a: any, b: any) =>
                preferredOrder.indexOf(a.categoryTitle) - preferredOrder.indexOf(b.categoryTitle)
            ),
        ...allCategoryData.filter((c: any) => !preferredOrder.includes(c.categoryTitle))
    ];
    const orderedCourses = [...filteredCourses].sort((a: any, b: any) => {
        const getPriority = (title: string) => {
            title = title?.toLowerCase() || '';
            if (title.includes('enrolled agent')) return 0;
            if (title.includes('cfe')) return 1;
            if (title.includes('cfcs')) return 2;
            if (title.includes('cams')) return 3;
            if (title.includes('ctp')) return 4;
            if (title.includes('finance manager')) return 5;
            if (title.includes('finance specialist')) return 6;
            if (title.includes('ifrs')) return 7;
            return 8; // Lowest priority for all other courses
        };

        const aPriority = getPriority(a.course_title);
        const bPriority = getPriority(b.course_title);

        return aPriority - bPriority;
    });
    const [filteredCoursess, setFilteredCourses] = useState<any[]>([]);

    useEffect(() => {
        const categoryId = id ? parseInt(id) : null;
        setSelectedCategoryId(categoryId);

        const filtered = categoryId
            ? allCourseData.filter((course: any) => course.categoryId === categoryId)
            : allCourseData;

        setFilteredCourses(filtered);
    }, [id, allCourseData]);
    return (
        <div>
            <Helmet>
                <title>Best Professional Courses in India | Meantoir Global Academy
                </title>
                <meta
                    name="description"
                    content="Explore the best professional courses in India at Meantoir Global Academy, including EA, CFE, 
CFS, CFM, and Diploma in IFRS exam preparation "
                />
                <link rel="canonical" href={`https://meantoir.com/course`} />
            </Helmet>
            {isLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <img src={loading} alt="Loading..." style={{ width: '400px', height: '400px' }} />
                </div>

            ) : (
                <div>
                    <Header />
                    <div className="about-page">
                        <div className="hero-section">
                            <img src={courseback} alt="About Hero" className="hero-image" />
                            <div className="overlay"></div>
                            <div className="hero-content">

                                <h1 style={{ textAlign: "center" }}>Courses</h1>
                                <div className="search-container">
                                    <span className="search-icon">
                                        <SearchOutlined onClick={handleSearch} style={{ cursor: "pointer" }} />
                                        {/* <img src={search} alt="search" onClick={handleSearch} style={{ cursor: "pointer" }} /> */}
                                    </span>
                                    <input
                                        type="text"
                                        // placeholder="Search e.g. Content Marketing"
                                        className="search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="courses-container">
                            {/* Sidebar - Categories */}
                            <div className="fixed-course">
                                <h2>Categories</h2>
                                <ul>
                                    <li
                                        onClick={() => navigate("/course")}
                                        style={{
                                            backgroundColor: selectedCategoryId === null ? "#e0e0e0" : "transparent",
                                            color: selectedCategoryId === null ? "#000" : "#333",
                                            fontWeight: selectedCategoryId === null ? "600" : "normal",
                                            padding: "6px 12px",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        All
                                    </li>

                                    {orderedCategoryData.map((category: any) => (
                                        <li
                                            key={category.id}
                                            onClick={() => navigate(`/course/category/${category.id}`)}
                                            style={{
                                                backgroundColor: selectedCategoryId === category.id ? "#e0e0e0" : "transparent",
                                                color: selectedCategoryId === category.id ? "#000" : "#333",
                                                fontWeight: selectedCategoryId === category.id ? "600" : "normal",
                                                padding: "6px 12px",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                                marginTop: "4px",
                                            }}
                                        >
                                            {category.categoryTitle}
                                        </li>
                                    ))}
                                </ul>

                            </div>

                            <div className="normal-courses">
                                {orderedCourses.map((course: any) => {
                                    const title = course.course_title?.toLowerCase();
                                    const isEnrolledAgent = title.includes("enrolled agent");
                                    const iscfe = title.includes("cfe");
                                    const iscfcs = title.includes("cfcs");
                                    const iscams = title.includes("cams");
                                    const isctp = title.includes("ctp");
                                    const isFinanceManager = title.includes("finance manager");
                                    const isfinancespecialist = title.includes("finance specialist");
                                    const isifrs = title.includes("ifrs");


                                    return (
                                        <div key={course.id} onClick={() => handleViewDetails(course.id)}>

                                            <div className="image-container">
                                                <img src={course.course_image} alt={course.course_title} className="course-image" />

                                            </div>
                                            <div >
                                                <h2 style={{ textAlign: "center" }}>
                                                    {course.course_title.replace(/\s*\(([^)]+)\)/, '\n($1)').split('\n').map((part: any, idx: any) => (
                                                        <React.Fragment key={idx}>
                                                            {part}
                                                            <br />
                                                        </React.Fragment>
                                                    ))}
                                                </h2>



                                                {(isEnrolledAgent || iscfe || iscfcs || iscams || isctp || isFinanceManager || isfinancespecialist || isifrs) && (
                                                    <div className="course-highlightss">
                                                        {isEnrolledAgent && (
                                                            <>
                                                                <p><strong>1 Book | 5–6 Months</strong></p>
                                                                <p>Earn up to <strong>10+ LPA</strong> in just 6 months!</p>
                                                                <p>Jobs at Big 4 & MNCs in India & Abroad</p>
                                                            </>
                                                        )}
                                                        {iscfe && (
                                                            <>
                                                                <p><strong>4 Exams | 3-4 Months </strong></p>
                                                                <p>Earn up to <strong>12+ LPA</strong> in just 4 months!</p>
                                                                <p>Jobs at Big 4, Banks, MNCs & Risk Consulting  <br /> <br />Firms </p>
                                                            </>
                                                        )}
                                                        {iscfcs && (
                                                            <>
                                                                <p><strong>3 Exams | 3-4 Months </strong></p>
                                                                <p>Earn up to <strong>12+ LPA</strong> in just 4 months!</p>
                                                                <p>Jobs at Big 4, Banks, MNCs & Risk Consulting Firms </p>
                                                            </>
                                                        )}
                                                        {iscams && (
                                                            <>
                                                                <p><strong>1 Exams | 3-4 Months </strong></p>
                                                                <p>Earn up to <strong>12+ LPA</strong> in just 4 months!</p>
                                                                <p>Jobs at Big 4, Global Banks, MNCs & FinTech <br />  <br /> Companies </p>
                                                            </>
                                                        )}
                                                        {isctp && (
                                                            <>
                                                                <p><strong>1 Exams | 3-4 Months </strong></p>
                                                                <p>Earn up to <strong>15+ LPA</strong> in just 4 months!</p>
                                                                <p>Jobs at Fortune 500 Companies, Big 4, Global<br /> <br /> Banks & MNCs</p>
                                                            </>
                                                        )}
                                                        {isFinanceManager && (
                                                            <>
                                                                <p><strong>1 Book | 2 Months</strong></p>
                                                                <p>Earn up to <strong>5 LPA</strong> in just 2 months!</p>
                                                                <p>Jobs at Big 4 & MNCs in India & Abroad</p>
                                                            </>
                                                        )}
                                                        {isfinancespecialist && (
                                                            <>
                                                                <p><strong>1 Book | 2 Months</strong></p>
                                                                <p>Earn up to <strong>5 LPA</strong> in just 2 months!</p>
                                                                <p>Jobs at Big 4 & MNCs in India & Abroad</p>
                                                            </>
                                                        )}
                                                        {isifrs && (
                                                            <>
                                                                <p><strong>1 Book | 2 Months</strong></p>
                                                                <p>Earn up to <strong>5 LPA</strong> in just 2 months!</p>
                                                                <p>Jobs at Big 4 & MNCs in India & Abroad</p>
                                                            </>
                                                        )}


                                                    </div>
                                                )}
                                                <div style={{ marginBottom: '8px' }}>
                                                    <Rate allowHalf disabled defaultValue={getRatingById(course.id)} />
                                                    {/* <span>{getRatingById(course.id)} / 5</span> */}
                                                </div>
                                            </div>

                                            <div className="button-container" style={{ display: 'flex', alignItems: 'center', gap: '10px', }}>
                                                <Button
                                                    className="courseCard-button primary-button"
                                                    onClick={(e) => showModal(course.id, e)}
                                                >
                                                    Enroll Now
                                                </Button>

                                                <Button className="courseCard-button primary-button" onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleViewDetails(course.id); // Make sure this calls the fixed function
                                                }} style={{ color: "white" }}>
                                                    View Details
                                                </Button>

                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        color: 'red',
                                                        fontSize: '16px'
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        shareOnWhatsApp(course);
                                                    }}
                                                >
                                                    <ShareAltOutlined style={{ fontSize: '20px', marginRight: '4px' }} />
                                                    <span>Share</span>
                                                </div>

                                                {isModalVisible && (
                                                    <EnrollModal
                                                        visible={isModalVisible}
                                                        onClose={handleCloseModal}
                                                        courseId={selectedCourseForEnroll}
                                                    />
                                                )}
                                            </div>

                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )}
        </div>
    )
}

export default Coursepage;
